import styled from "styled-components";
import styledMap from "styled-map";

import theme from "config/theme";

import { H4 } from "components/Text";
import Button from "components/Button";
import StyledImage from "components/Image";

export const Wrapper = styled.a`
  position: relative;
  overflow: hidden;
  text-align: left;

  &:hover {
    button {
      transform: scale(1.1);
    }

    img {
      opacity: 0.08;
    }
  }
`;

export const Inner = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  padding: 30px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${theme.size.mobile}) {
    padding: 25px;
  }
`;

export const Date = styled.span`
  margin-bottom: 10px;
  display: table;
  cursor: pointer;
  color: ${theme.color.primary};
  font-size: ${theme.font.size.zeta};
`;

export const Title = styled(H4)`
  line-height: 1.4;
  margin-bottom: 0;
  width: 100%;
  flex: 1;
  color: white;
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.upsilon};

  @media (max-width: ${theme.size.tablet}) {
    font-size: ${theme.font.size.theta};
  }

  @media (max-width: ${theme.size.mobile}) {
    font-size: ${theme.font.size.upsilon};
  }
`;

export const Image = styled(StyledImage)`
  position: absolute !important;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0.03;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: grayscale(100%);
  transition: ${theme.transition};
`;

export const PlayButton = styled(Button)`
  z-index: 1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  z-index: 2;
  flex-shrink: 0;
  width: 45px;
  height: 45px;
  font-size: 18px;

  @media (min-width: ${theme.size.tablet}) {
    width: ${styledMap("isFeatured", {
      true: "90px",
      false: "45px"
    })};

    height: ${styledMap("isFeatured", {
      true: "90px",
      false: "45px"
    })};

    font-size: ${styledMap("isFeatured", {
      true: "35px",
      false: "18px"
    })};
  }

  &:active {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(0.96);
  }
`;
